// src/context/errors/globalShowError.js   -- обёртка для глобального вызова showError
let _showError = () => {};

export const registerShowError = (fn) => {
  _showError = fn;
};

export const showError = (error) => {
  _showError(error);
};
